module.exports = "/static-assets/_next/static/images/yourRatCompanion-5d14982df474d1af6c1e8a31fdb6d60f.png";